import React from 'react';
import { Typography } from '@guildeducationinc/recess';
import { FilterPane } from 'src/components/FilterPane';
import classnames from 'classnames';
import styles from './DesktopFilters.module.scss';

export const DesktopFilters: React.FC = () => {
	return (
		<div className={classnames([styles.filterContainer, styles.newSearch])}>
			<div className={styles.filterHeaders}>
				<Typography variant='h5'>Filter all programs</Typography>
			</div>
			<FilterPane />
		</div>
	);
};
